module.exports = __webpack_public_path__ + "static/media/C034.4011c6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C034.jpg
// module id = 317
// module chunks = 0